import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import ReactModal from 'react-modal';
import { errors } from '@yola/ws-sdk';
import constants from 'src/js/modules/common/constants';
import store from 'src/js/store';
import errorCatcher from 'src/js/modules/error/helpers/error-catcher';
import userAgent from './user-agent';
import ErrorBoundary from './error-boundary';
import initApp from './init-app';
import Main from './main';

/*
  In order to prevent tracking redundant errors with "Network error"
  message we need to establish global variable on "beforeunload" event
  and use it in "errorHandler" middleware to prevent tracking such error
*/
window.addEventListener('beforeunload', () => {
  // eslint-disable-next-line no-underscore-dangle
  window._ws_resources_unloaded = true;
});

/*
  This listener indicates if a webpage is loaded from the cache.
  In this case we should reload the page.
  It's related to this issue: https://github.com/yola/production/issues/7572
*/
window.addEventListener('pageshow', (event) => event.persisted && window.location.reload());

userAgent.detect();
ReactModal.setAppElement(constants.common.APP_ELEMENT_SELECTOR);

initApp().then(() => {
  const root = createRoot(document.getElementById('app'));

  root.render(
    <Provider store={store}>
      <ErrorBoundary>
        <Main />
      </ErrorBoundary>
    </Provider>
  );
});

errors.operations.registerCatcher(errorCatcher);
